import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'

const enabledReleaseStages = ["DEVELOPMENT", "HOMOLOGACAO", "PRODUCTION"]
const isBugsnagEnabled = enabledReleaseStages.includes(process.env.REACT_APP_ENV)

// Fora dos releaseStages acima (ex: REACT_APP_ENV=local), o Bugsnag nem inicializa —
// evita chamadas de rede e ruído no console em dev local sem API key.
const bugsnagClient = isBugsnagEnabled
  ? Bugsnag.start({
      apiKey: process.env.REACT_APP_BUGSNAG_KEY,
      plugins: [new BugsnagPluginReact()],
      enabledReleaseStages,
      releaseStage: process.env.REACT_APP_ENV,
      appVersion: '1.0'
    })
  : {
      getPlugin: () => ({ createErrorBoundary: () => ({ children }) => children }),
      setUser: () => {}
    }

export { isBugsnagEnabled }
export default bugsnagClient
